module.exports = __webpack_public_path__ + "static/Circit-f8d73151d7742e649566895ca68a7f3f.jpg";